export const heroSlides = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    title: "Travel with Peace of Mind",
    subtitle: "At Tripsecure, it's built into your journey.",
    description:
      "Experience seamless protection for every trip with our innovative insurance platform.",
    cta: "Get Started",
    layout: "left-image",
    shieldPosition: "bottom-right",
    colorScheme: "green",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    title: "Protection isn't a luxury",
    subtitle: "At Tripsecure, it's built into your journey.",
    description:
      "Get covered in seconds with our AI-powered instant activation system.",
    cta: "Learn More",
    layout: "right-image",
    shieldPosition: "bottom-left",
    colorScheme: "blue",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80",
    title: "Every journey deserves a safety net",
    subtitle: "That's why we insure moments, not just smiles.",
    description:
      "From daily commutes to international adventures, your safety is our priority.",
    cta: "Explore Coverage",
    layout: "left-image",
    shieldPosition: "bottom-right",
    colorScheme: "purple",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    title: "When you travel with loved ones",
    subtitle: "We travel with you quietly protecting every step.",
    description:
      "Join thousands of travelers who choose Tripsecure for their peace of mind.",
    cta: "Join Now",
    layout: "right-image",
    shieldPosition: "bottom-left",
    colorScheme: "yellow",
  },
  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    title: "Tripsecure is where innovation meets impact",
    subtitle: "Safety you can see, value you can feel.",
    description:
      "Experience the future of travel protection with cutting-edge technology.",
    cta: "Discover More",
    layout: "left-image",
    shieldPosition: "bottom-right",
    colorScheme: "teal",
  },
];

